import { render, staticRenderFns } from "./RecordIndex.vue?vue&type=template&id=e8328ea4&scoped=true&"
import script from "./RecordIndex.vue?vue&type=script&lang=js&"
export * from "./RecordIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8328ea4",
  null
  
)

export default component.exports